import Rest from '@/services/Rest'

export default class CompanyService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/companies';

  modelsByCode(record) {
    return this.get(`/models/${this.getCode(record)}`)
  }

  mandatoryModels(code, data) {
    return this.put(`/mandatoryModels/${code}`, data)
  }


}
